import Axios from "@/utils/Axios";
import config from "@/config";

export const getHeartIconStatus = () => {
  return Axios.get("/heart-coin/balance", {}, {}, config.creatorUrl);
};

export const getAccelerateStatus = () => {
  return Axios.get("/subscribe/status", {}, {}, config.creatorUrl);
};
